var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "import-form" },
    [
      _c(
        "a-steps",
        {
          staticClass: "import-steps",
          attrs: { type: "navigation", size: "small" },
          model: {
            value: _vm.current,
            callback: function ($$v) {
              _vm.current = $$v
            },
            expression: "current",
          },
        },
        [
          !_vm.skipPlatformSelection
            ? _c("a-step", {
                attrs: {
                  title: "Platform Seçimi",
                  description: "Kişiler nerede kullanılacak?",
                  status: _vm.current === 0 ? "process" : "wait",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("a-step", {
            attrs: {
              title: "Dosya Seçimi",
              description: "CSV veya Excel dosyası seçin",
              status: _vm.skipPlatformSelection
                ? _vm.current === 0
                  ? "process"
                  : "wait"
                : _vm.current === 1
                ? "process"
                : "wait",
            },
          }),
          _vm._v(" "),
          _c("a-step", {
            attrs: {
              title: "İçe Aktarma Ayarları",
              description: "Dosyanızı özelleştirin",
              status: _vm.skipPlatformSelection
                ? _vm.current === 1
                  ? "process"
                  : "wait"
                : _vm.current === 2
                ? "process"
                : "wait",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "import-card" }, [
        _vm.current === 0 && !_vm.skipPlatformSelection
          ? _c("div", { staticClass: "platformSelection" }, [
              _c("h3", [_vm._v("Platform Seçimi")]),
              _vm._v(" "),
              _c("div", { staticClass: "platform-options" }, [
                _c(
                  "div",
                  {
                    staticClass: "platform-option",
                    class: { selected: _vm.selectedPlatform === "supsis" },
                    on: {
                      click: function ($event) {
                        return _vm.setPlatform("supsis")
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "platform-icon" },
                      [_c("DynamicSvg", { attrs: { name: "CSupsis" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "platform-name" }, [
                      _vm._v("Supsis"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "platform-option",
                    class: { selected: _vm.selectedPlatform === "email" },
                    on: {
                      click: function ($event) {
                        return _vm.setPlatform("email")
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "platform-icon" },
                      [_c("DynamicSvg", { attrs: { name: "Mail" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "platform-name" }, [
                      _vm._v("Mail"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "platform-option",
                    class: { selected: _vm.selectedPlatform === "whatsapp" },
                    on: {
                      click: function ($event) {
                        return _vm.setPlatform("whatsapp")
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "platform-icon" },
                      [_c("DynamicSvg", { attrs: { name: "Whatsapp" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "platform-name" }, [
                      _vm._v("Whatsapp"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.selectedPlatform === "whatsapp" &&
              _vm.whatsappChannels.length > 0
                ? _c(
                    "div",
                    { staticClass: "channel-selection" },
                    [
                      _c("h4", [_vm._v("Kanal Seçimi")]),
                      _vm._v(" "),
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { mode: "multiple" },
                          model: {
                            value: _vm.selectedChannels,
                            callback: function ($$v) {
                              _vm.selectedChannels = $$v
                            },
                            expression: "selectedChannels",
                          },
                        },
                        _vm._l(_vm.whatsappChannels, function (channel) {
                          return _c(
                            "a-select-option",
                            { key: channel._id, attrs: { value: channel._id } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(channel.name) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-action" },
                [
                  _c("a-button", { on: { click: _vm.onCancelled } }, [
                    _vm._v("İptal"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", disabled: !_vm.canProceed },
                      on: { click: _vm.goToNextStep },
                    },
                    [_vm._v("İleri")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        (_vm.current === 1 && !_vm.skipPlatformSelection) ||
        (_vm.current === 0 && _vm.skipPlatformSelection)
          ? _c("div", { staticClass: "file-selection" }, [
              _c("h3", [_vm._v("Dosya Seçimi")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "file-box", on: { click: _vm.openSelectFile } },
                [
                  _c(
                    "div",
                    {},
                    [
                      _c("a-icon", {
                        staticStyle: { "font-size": "50px", color: "#08c" },
                        attrs: { type: "file-excel" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "file-details" }, [
                    _vm.file
                      ? _c("span", [_vm._v(_vm._s(_vm.file.name))])
                      : _c("span", [_vm._v("Dosya Seçin")]),
                    _vm._v(" "),
                    _c("span", [_vm._v("CSV veya Excel Dosyası")]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-action" },
                [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.current === 0 ? _vm.onCancelled : _vm.current--
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.current === 0 ? "İptal" : "Geri") +
                          "\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", disabled: !_vm.file },
                      on: { click: _vm.goToNextStep },
                    },
                    [_vm._v("İleri")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        (_vm.current === 2 && !_vm.skipPlatformSelection) ||
        (_vm.current === 1 && _vm.skipPlatformSelection)
          ? _c("div", { staticClass: "file-configuration" }, [
              _c("h3", [_vm._v("İçe Aktarma Ayarları")]),
              _vm._v(" "),
              _c("div", { staticClass: "config-content" }, [
                _c("div", { staticClass: "config-left" }, [
                  _c(
                    "section",
                    { staticClass: "config-section general-section" },
                    [
                      _c("h4", [_vm._v("Genel Ayarlar")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "general-options" }, [
                        _c(
                          "div",
                          { staticClass: "option-field" },
                          [
                            _c("label", [_vm._v("İlk satırda başlık var mı?")]),
                            _vm._v(" "),
                            _c("a-switch", {
                              model: {
                                value: _vm.firstRowContainsHeader,
                                callback: function ($$v) {
                                  _vm.firstRowContainsHeader = $$v
                                },
                                expression: "firstRowContainsHeader",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.excelMode
                          ? _c(
                              "div",
                              { staticClass: "option-field" },
                              [
                                _c("label", [_vm._v("Ayırıcı Karakter")]),
                                _vm._v(" "),
                                _c(
                                  "a-select",
                                  {
                                    model: {
                                      value: _vm.separator,
                                      callback: function ($$v) {
                                        _vm.separator = $$v
                                      },
                                      expression: "separator",
                                    },
                                  },
                                  [
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: "," } },
                                      [_vm._v("Virgül (,)")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-select-option",
                                      { attrs: { value: ";" } },
                                      [_vm._v("Noktalı Virgül (;)")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "config-section fields-section" },
                    [
                      _c("h4", [_vm._v("Alan Eşleştirme")]),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "fields-container" },
                        _vm._l(Object.keys(_vm.mapping), function (field) {
                          return _c(
                            "div",
                            { key: field, staticClass: "field-row" },
                            [
                              _c(
                                "div",
                                { staticClass: "field-item" },
                                [
                                  _c("a-select", {
                                    attrs: {
                                      options: _vm.getSelectOptionsForFields(),
                                      value: field,
                                      disabled: true,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._m(1, true),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "field-item" },
                                [
                                  _c(
                                    "a-radio-group",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        gap: "5px",
                                        "margin-bottom": "5px",
                                      },
                                      attrs: { value: _vm.mappingTypes[field] },
                                      on: {
                                        change: function (e) {
                                          return _vm.onMappingTypeChange(
                                            field,
                                            e.target.value
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "column" } },
                                        [_vm._v("Sütun")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-radio-button",
                                        { attrs: { value: "static" } },
                                        [_vm._v("Sabit Değer")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.mappingTypes[field] === "column"
                                    ? _c(
                                        "a-select",
                                        {
                                          attrs: { value: _vm.mapping[field] },
                                          on: {
                                            change: function (value) {
                                              return _vm.changeFieldValue(
                                                field,
                                                value
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._l(
                                            _vm.getSelectOptionsForColumns(),
                                            function (option) {
                                              return _c(
                                                "a-select-option",
                                                {
                                                  key: option.value,
                                                  attrs: {
                                                    value: option.value,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s(option.label) +
                                                      "\n                                        "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "a-select-option",
                                            { attrs: { value: "" } },
                                            [_vm._v("Boş")]
                                          ),
                                        ],
                                        2
                                      )
                                    : _c("a-input", {
                                        attrs: {
                                          value: _vm.staticValues[field],
                                          placeholder: "Sabit değer girin",
                                        },
                                        on: {
                                          change: function (e) {
                                            return _vm.changeStaticValue(
                                              field,
                                              e.target.value
                                            )
                                          },
                                        },
                                      }),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "config-section advanced-section" },
                    [
                      _c(
                        "a-collapse",
                        [
                          _c(
                            "a-collapse-panel",
                            { key: "1", attrs: { header: "Gelişmiş Ayarlar" } },
                            [
                              _c("div", { staticClass: "advanced-options" }, [
                                _c(
                                  "div",
                                  { staticClass: "advanced-field" },
                                  [
                                    _c("label", [_vm._v("Etiketler")]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        items: _vm.tags,
                                        "id-key": "_id",
                                        "label-key": "name",
                                        title: "Etiket Seçin",
                                        icon: "label",
                                        multiple: true,
                                      },
                                      model: {
                                        value: _vm.advancedSettings.tags,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.advancedSettings,
                                            "tags",
                                            $$v
                                          )
                                        },
                                        expression: "advancedSettings.tags",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v(
                                        "Oluşturulacak kişilere eklenecek etiketler"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "advanced-field" },
                                  [
                                    _c("label", [_vm._v("Departmanlar")]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        items: _vm.getDepartmentItems(),
                                        "id-key": "_id",
                                        "label-key": "name",
                                        title: "Departman Seçin",
                                        icon: "business",
                                        multiple: true,
                                      },
                                      model: {
                                        value:
                                          _vm.advancedSettings
                                            .relatedDepartments,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.advancedSettings,
                                            "relatedDepartments",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "advancedSettings.relatedDepartments",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v(
                                        "Kişilerin ilişkilendirileceği departmanlar"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "advanced-field" },
                                  [
                                    _c("label", [
                                      _vm._v("Tercih Edilen Temsilciler"),
                                    ]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        items: _vm.users,
                                        "id-key": "_id",
                                        "label-key": "name",
                                        title: "Temsilci Seçin",
                                        icon: "support_agent",
                                        multiple: true,
                                      },
                                      model: {
                                        value:
                                          _vm.advancedSettings.preferredAgents,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.advancedSettings,
                                            "preferredAgents",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "advancedSettings.preferredAgents",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v(
                                        "Kişilere atanacak tercih edilen temsilciler"
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "advanced-field" },
                                  [
                                    _c("label", [_vm._v("Sahiplik")]),
                                    _vm._v(" "),
                                    _c("CustomPicker", {
                                      attrs: {
                                        items: _vm.users,
                                        "id-key": "_id",
                                        "label-key": "name",
                                        title: "Sahip Seçin",
                                        icon: "assignment_ind",
                                        multiple: false,
                                      },
                                      model: {
                                        value: _vm.advancedSettings.owner,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.advancedSettings,
                                            "owner",
                                            $$v
                                          )
                                        },
                                        expression: "advancedSettings.owner",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v("Kişilere sahiplik atanacak mı?"),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "advanced-field vip-field" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "field-with-switch" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "field-label-group" },
                                          [
                                            _c("label", [
                                              _vm._v("VIP Müşteri"),
                                            ]),
                                            _vm._v(" "),
                                            _c("small", [
                                              _vm._v(
                                                "Kişiler VIP olarak işaretlensin mi?"
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("a-switch", {
                                          model: {
                                            value:
                                              _vm.advancedSettings.vipCustomer,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.advancedSettings,
                                                "vipCustomer",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "advancedSettings.vipCustomer",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "advanced-field" },
                                  [
                                    _c("label", [_vm._v("Not")]),
                                    _vm._v(" "),
                                    _c("small", [
                                      _vm._v("Tüm kişilere eklenecek not"),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-textarea", {
                                      attrs: {
                                        rows: 4,
                                        placeholder:
                                          "Kişilere eklenecek notu buraya yazın",
                                      },
                                      model: {
                                        value: _vm.advancedSettings.note,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.advancedSettings,
                                            "note",
                                            $$v
                                          )
                                        },
                                        expression: "advancedSettings.note",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "config-right" }, [
                  _c(
                    "section",
                    { staticClass: "config-section preview-section" },
                    [
                      _c("h4", [_vm._v("Önizleme")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "preview-table" },
                        [
                          _c("ve-table", {
                            attrs: {
                              columns: _vm.getTableDataSource().columns,
                              "table-data": _vm.getTableDataSource().rows,
                              "row-style-option": _vm.rowStyleOption,
                              "border-x": true,
                              "border-y": true,
                              "row-key-field-name": "phone",
                              id: "import-preview-table",
                              "fixed-header": true,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-action" },
                [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.current--
                        },
                      },
                    },
                    [_vm._v("Geri")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.importing },
                      on: { click: _vm.importContacts },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.importing
                              ? "İçe Aktarılıyor..."
                              : "Kişileri İçe Aktar"
                          ) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fields-header" }, [
      _c("div", [_vm._v("SUPSIS ALANI")]),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div", [_vm._v("KAYNAK")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-arrow" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("arrow_forward")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }